import { useEffect } from 'react';

/** A mesma chave que a Rede do WhatsApp usa para a última conta aberta neste navegador. */
const ACCOUNT_KEY = 'wa_rede_account';

/**
 * Cópia da Rede do WhatsApp no servidor (decisão 468) em qualquer página do painel: com alguém
 * logado e uma Rede neste navegador, liga o sincronismo, que junta as mudanças por 1 minuto e envia
 * em lotes. O código da Rede só carrega aqui quando há Rede neste navegador.
 */
export function useRedeCloudSync(userId: string | undefined): void {
  useEffect(() => {
    if (!userId) return undefined;
    let account: string | null = null;
    try {
      account = window.localStorage.getItem(ACCOUNT_KEY);
    } catch {
      account = null;
    }
    if (!account) return undefined;
    let cancelled = false;
    void import('../features/whatsappGroups/networkCloud').then((cloud) => {
      if (!cancelled) cloud.startCloudForShell(account!);
    });
    return () => {
      cancelled = true;
      void import('../features/whatsappGroups/networkCloud').then((cloud) => cloud.stopCloudForShell());
    };
  }, [userId]);
}
